import React, { useState } from "react";
import API from "../services/api";

export default function Promotion() {

    const [currentYear, setCurrentYear] = useState("2026-27");
    const [newYear, setNewYear] = useState("2027-28");

    const [currentClass, setCurrentClass] = useState("");
    const [currentSection, setCurrentSection] = useState("A");

    const [newClass, setNewClass] = useState("");
    const [newSection, setNewSection] = useState("A");

    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectedStudents, setSelectedStudents] = useState([]);

    const classList = [
        "PP1",
        "PP2",
        "LKG",
        "UKG",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10"
    ];

    const sectionList = [
        "A",
        "B",
        "C",
        "D"
    ];

    const loadStudents = async () => {

        if (!currentClass) {

            alert("Please select Current Class");

            return;
        }

        try {

            setLoading(true);

            const res = await API.get(
                "/promotion/students",
                {
                    params: {
                        class_name: currentClass,
                        section: currentSection
                    }
                }
            );

            setStudents(res.data);

        } catch (err) {

            alert("Unable to load students");

        } finally {

            setLoading(false);
        }
    };

    const handleSelectAll = (e) => {

        if (e.target.checked) {

            setSelectedStudents(
                students.map(student => student.id)
            );

        } else {

            setSelectedStudents([]);
        }

    };

    const handleStudentSelect = (id) => {

        if (selectedStudents.includes(id)) {

            setSelectedStudents(

                selectedStudents.filter(

                    studentId => studentId !== id

                )

            );

        } else {

            setSelectedStudents([

                ...selectedStudents,

                id

            ]);

        }

    };

    const promoteStudents = async () => {

        if (selectedStudents.length === 0) {

            alert("Please select at least one student.");

            return;

        }

        if (!newClass) {

            alert("Please select Promote To Class.");

            return;

        }

        try {

            const res = await API.post(

                "/promotion/promote",

                {

                    studentIds: selectedStudents,

                    currentYear,

                    newYear,

                    currentClass,

                    currentSection,

                    newClass,

                    newSection

                }

            );

            alert(res.data.message);

        }

        catch (err) {

            alert(

                err.response?.data?.message ||

                "Promotion failed."

            );

        }

    };

    return (

        <div className="p-8">

            <div className="bg-white rounded-3xl shadow-xl border">

                <div className="bg-blue-700 text-white rounded-t-3xl px-8 py-6">

                    <h1 className="text-3xl font-bold">

                        🎓 Student Promotion

                    </h1>

                    <p className="opacity-90 mt-2">

                        Promote students into the next academic year.

                    </p>

                </div>

                <div className="p-8">

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">

                        <div>

                            <label className="block font-semibold mb-2">

                                Current Academic Year

                            </label>

                            <input

                                value={currentYear}

                                onChange={(e) => setCurrentYear(e.target.value)}

                                className="border rounded-xl w-full p-3"

                            />

                        </div>

                        <div>

                            <label className="block font-semibold mb-2">

                                New Academic Year

                            </label>

                            <input

                                value={newYear}

                                onChange={(e) => setNewYear(e.target.value)}

                                className="border rounded-xl w-full p-3"

                            />

                        </div>

                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">

                        <div>

                            <label className="block font-semibold mb-2">

                                Current Class

                            </label>

                            <select

                                value={currentClass}

                                onChange={(e) => setCurrentClass(e.target.value)}

                                className="border rounded-xl w-full p-3"

                            >

                                <option value="">Select Class</option>

                                {

                                    classList.map(cls => (

                                        <option

                                            key={cls}

                                            value={cls}

                                        >

                                            {cls}

                                        </option>

                                    ))

                                }

                            </select>

                        </div>

                        <div>

                            <label className="block font-semibold mb-2">

                                Current Section

                            </label>

                            <select

                                value={currentSection}

                                onChange={(e) => setCurrentSection(e.target.value)}

                                className="border rounded-xl w-full p-3"

                            >

                                {

                                    sectionList.map(sec => (

                                        <option

                                            key={sec}

                                            value={sec}

                                        >

                                            {sec}

                                        </option>

                                    ))

                                }

                            </select>

                        </div>

                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">

                        <div>

                            <label className="block font-semibold mb-2">

                                Promote To Class

                            </label>

                            <select

                                value={newClass}

                                onChange={(e) => setNewClass(e.target.value)}

                                className="border rounded-xl w-full p-3"

                            >

                                <option value="">Select Class</option>

                                {

                                    classList.map(cls => (

                                        <option

                                            key={cls}

                                            value={cls}

                                        >

                                            {cls}

                                        </option>

                                    ))

                                }

                            </select>

                        </div>

                        <div>

                            <label className="block font-semibold mb-2">

                                Promote To Section

                            </label>

                            <select

                                value={newSection}

                                onChange={(e) => setNewSection(e.target.value)}

                                className="border rounded-xl w-full p-3"

                            >

                                {

                                    sectionList.map(sec => (

                                        <option

                                            key={sec}

                                            value={sec}

                                        >

                                            {sec}

                                        </option>

                                    ))

                                }

                            </select>

                        </div>

                    </div>

                    <button

                        onClick={loadStudents}

                        className="bg-blue-700 hover:bg-blue-800 text-white px-8 py-3 rounded-xl font-semibold"

                    >

                        {loading ? "Loading..." : "Load Students"}

                    </button>

                    <div className="mt-8 border rounded-2xl overflow-hidden">

                        <div className="bg-gray-100 px-6 py-4 font-bold text-lg">

                            Students Eligible for Promotion

                        </div>

                        <table className="w-full">

                            <thead className="bg-gray-50">
                                <tr>

                                    <th className="p-4">

                                        <input

                                            type="checkbox"

                                            checked={
                                                students.length > 0 &&
                                                selectedStudents.length === students.length
                                            }

                                            onChange={handleSelectAll}

                                        />

                                    </th>

                                    <th className="text-left p-4">

                                        Admission No

                                    </th>

                                    <th className="text-left p-4">

                                        Student Name

                                    </th>

                                    <th className="text-left p-4">

                                        Class

                                    </th>

                                    <th className="text-left p-4">

                                        Section

                                    </th>

                                </tr>
                               

                            </thead>

                            <tbody>

                                {

                                    students.length === 0 ?

                                        (

                                            <tr>

                                                <td

                                                    colSpan="4"

                                                    className="text-center p-8 text-gray-500"

                                                >

                                                    No students loaded.

                                                </td>

                                            </tr>

                                        )

                                        :

                                        (

                                            students.map(student => (

                                                <tr

                                                    key={student.id}

                                                    className="border-t hover:bg-blue-50"

                                                >
                                                    <td className="p-4">

                                                        <input

                                                            type="checkbox"

                                                            checked={selectedStudents.includes(student.id)}

                                                            onChange={() =>
                                                                handleStudentSelect(student.id)
                                                            }

                                                        />

                                                    </td>
                                                    <td className="p-4">

                                                        {student.admission_no}

                                                    </td>

                                                    <td className="p-4">

                                                        {student.name}

                                                    </td>

                                                    <td className="p-4">

                                                        {student.class}

                                                    </td>

                                                    <td className="p-4">

                                                        {student.section}

                                                    </td>

                                                </tr>

                                            ))

                                        )

                                }

                            </tbody>

                        </table>

                        <div className="flex justify-between items-center mt-6">

                            <div className="font-bold text-blue-700">

                                Selected Students : {selectedStudents.length}

                            </div>

                            <button

                                onClick={promoteStudents}

                                disabled={selectedStudents.length === 0}

                                className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl disabled:opacity-50"

                            >

                                Promote Selected Students

                            </button>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}